import { observer } from "mobx-react-lite";
import Playground from "../../Playground/Playground";

const ImageEditingDemo = () => {
	return <Playground />;
};

export default observer(ImageEditingDemo);
